import {Module} from 'vuex';
import {SettingState, RootState} from '../types';
import {getBackground} from '@/api/system';

const settings: Module<SettingState, RootState> = {
  namespaced: true,
  state: {
    background: '',
    regionId: '',
    contactNumber: '',
    address: '',
    faceIcon: '',
    link: '',
    businessHours: '',
    isShowNav: false,
    homeMapColor: '',
    homeMapUrl: '',
    roomMapColor: '',
    roomMapUrl: '',
    shareIcon: '',
    title: '',
    shareTitle: ''
  },
  mutations: {
    SET_SETTING(state: SettingState, setting: any) {
      state.background = setting.themeStyle;
      state.regionId = setting.regionId;
      state.contactNumber = setting.contactNumber;
      state.address = setting.address;
      state.faceIcon = setting.faceIcon;
      state.link = setting.link;
      state.businessHours = setting.businessHours;
      state.isShowNav = setting.isShowNav;
      state.homeMapColor = setting.homeMapColor;
      state.homeMapUrl = setting.homeMapUrl;
      state.roomMapColor = setting.roomMapColor;
      state.roomMapUrl = setting.roomMapUrl;

      state.shareIcon = setting.shareIcon;
      state.title = setting.title;
      state.shareTitle = setting.shareTitle;
    }
  },
  actions: {
    async setSetting({commit}) {
      const result = await getBackground();
      commit('SET_SETTING', result);
    }
  }
};

export default settings;
